module.exports = __webpack_public_path__ + "static/media/plus-inside-circle.9cd2ef3a.svg";